/**
 * better-auth stores organization roles and invitation statuses as lowercase strings. The
 * Members and Invitations pages show them as badges with translated, capitalised labels,
 * and filter on them. One map per value set drives both the column's badge and the
 * filter's options, so the two can never disagree.
 */
type TagMap = Record<string, { labelKey: string; type: string }>;

export const ORG_ROLE_TAGS: TagMap = {
  owner: { labelKey: 'orgSettings.members.owner', type: 'purple' },
  admin: { labelKey: 'orgSettings.members.admin', type: 'blue' },
  member: { labelKey: 'orgSettings.members.member', type: 'cool-gray' },
};

export const INVITATION_STATUS_TAGS: TagMap = {
  pending: { labelKey: 'orgSettings.invitations.statuses.pending', type: 'cyan' },
  accepted: { labelKey: 'orgSettings.invitations.statuses.accepted', type: 'green' },
  rejected: { labelKey: 'orgSettings.invitations.statuses.rejected', type: 'red' },
  canceled: { labelKey: 'orgSettings.invitations.statuses.canceled', type: 'gray' },
};

/** An enum filter's options, in the tag map's own order. */
export const tagOptions = (map: TagMap) => Object.entries(map).map(([id, { labelKey }]) => ({ id, labelKey }));
